export const APSAPI = `https://khachhang.prudential.com.vn/pruonline-api/rest/public/aps`; //Production

// export const URLink = `https://bit.ly/Prudential-LKDV2020`;
// export const VLLink = `https://bit.ly/Prudential-LKC2020`;
// export const OtherLink = `https://bit.ly/Prudential-QCHD2020`;
// export const APSAPI = `https://portal-uat.prudential.com.vn/pruonline-api-rhsso/rest/public/aps`; //UAT
// export const APSAPI = `https://portal.prudential.com.vn/pruonline-api-uat/rest/public/aps`; //PORTAL
// export const APSAPI = `https://portal.prudential.com.vn/pruonline-api/rest/public/aps`; //Production
// export const APSAPI = `http://localhost:8080/pruonline-api-rhsso/rest/public/aps`;
export const URLink = `https://bit.ly/Prudential-LKDV2025`;
export const VLLink = `https://bit.ly/Prudential-LKC2025`;
export const HTLink = `https://bit.ly/Prudential-HTTN2025`;
export const OtherLink = `https://bit.ly/Prudential-QCHD2025`;
